import { ThreeDots } from "react-loader-spinner";
import { getStatColorTokens } from "./statColors";

/**
 * StatChips — "Toplam 128 / Hatalı 3" tarzı istatistik rozetleri.
 *
 * PageHeader'ın içinden çıkarıldı: sekmeli sayfalarda (ör. Ödemeler) başlık
 * üstte tek sefer durduğu için rozetlerin başlık satırından bağımsız olarak,
 * filtre butonlarıyla AYNI satırda gösterilebilmesi gerekiyordu. Artık hem
 * PageHeader hem ListToolbar aynı bileşeni kullanır.
 *
 * @param {Array<{label,value,icon?,color?}>} stats
 * @param {boolean} [isLoading] - değer yerine spinner
 */
export default function StatChips({ stats = [], isLoading = false }) {
  if (!stats.length) return null;
  return (
    <>
      {stats.map((stat) => {
        const sc = getStatColorTokens(stat.color || "indigo");
        const StatIcon = stat.icon;
        return (
          <div
            key={stat.label}
            className={`flex items-center gap-1.5 sm:gap-2 ${sc.statBg} rounded-md sm:rounded-lg px-2.5 sm:px-3 py-1.5 sm:py-2 border ${sc.statBorder}`}
          >
            {StatIcon && (
              <StatIcon
                className={`${sc.statIcon} w-3.5 h-3.5 sm:w-4 sm:h-4 shrink-0`}
              />
            )}
            <span className={`text-xs sm:text-base font-bold ${sc.statValue}`}>
              {isLoading ? (
                <ThreeDots
                  visible
                  height={10}
                  width={20}
                  color={sc.loader}
                  ariaLabel="loading"
                />
              ) : (
                stat.value
              )}
            </span>
            <span
              className={`text-[10px] sm:text-xs ${sc.statLabel} font-medium hidden sm:inline`}
            >
              {stat.label}
            </span>
          </div>
        );
      })}
    </>
  );
}
